export default __webpack_public_path__ + "static/media/cloud.cc2d788b.svg";